<template>
  <div class="main-container">
    <div class="header">
      <div class="nav-item active">
        <div class="txt">
          账号管理
        </div>
      </div>
      <div
        class="nav-item"
        @click="$router.push('/systemmanager/systemExperiment')"
      >
        <span>
          成绩管理
        </span>
      </div>
      <div class="nav-item" @click="$router.push('/systemmanager/systemTotal')">
        <span>
          历史记录
        </span>
      </div>
    </div>
    <div class="search-wrap">
      <el-row :gutter="16" style="width: 100%">
        <el-col :span="6">
          <div class="input">
            <input
              type="text"
              placeholder="请输入学校名称"
              v-model="searchParams.student.schoolName"
              @keyup.enter="getList"
            />
          </div>
        </el-col>
        <el-col :span="6">
          <div class="input">
            <input
              type="text"
              placeholder="请输入班级"
              v-model="searchParams.student.className"
              @keyup.enter="getList"
            />
          </div>
        </el-col>
        <el-col :span="6">
          <div class="input">
            <input
              type="text"
              placeholder="请输入姓名"
              v-model="searchParams.student.realName"
              @keyup.enter="getList"
            />
          </div>
        </el-col>
        <el-col :span="6">
          <div class="btn">
            <button @click="getList">
              搜索 search
            </button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="main">
      <!--      <el-row :gutter="10">-->
      <!--        <el-col :span="6">-->
      <!--          <div-->
      <!--              style="font-size: 14px;font-weight: bolder;border-radius: 10px;border: 1px solid #e5e5e5;padding:6px;margin-bottom: 6px">-->
      <!--            班级数：{{clazzTotal}}-->
      <!--          </div>-->
      <!--        </el-col>-->
      <!--        <el-col :span="6">-->
      <!--          <div-->
      <!--              style="font-size: 14px;font-weight: bolder;border-radius: 10px;border: 1px solid #e5e5e5;padding:6px;margin-bottom: 6px">-->
      <!--            学生数：{{studentTotal}}-->
      <!--          </div>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <div class="table-wrap">
        <el-table
          :data="list"
          border
          size="small"
          header-cell-class-name="my-header"
          style="width: 100%;"
        >
          <el-table-column
            prop="schoolName"
            align="center"
            min-width="100"
            show-overflow-tooltip
            label="学校"
          >
          </el-table-column>
          <el-table-column
            prop="className"
            align="center"
            min-width="100"
            show-overflow-tooltip
            label="班级"
          >
          </el-table-column>
          <el-table-column
            prop="studentNo"
            align="center"
            min-width="100"
            show-overflow-tooltip
            label="学号"
          >
          </el-table-column>
          <el-table-column
            prop="realName"
            align="center"
            min-width="100"
            show-overflow-tooltip
            label="姓名"
          >
          </el-table-column>
          <el-table-column
            prop="userName"
            align="center"
            show-overflow-tooltip
            label="用户名"
          >
          </el-table-column>
          <el-table-column
            prop="password"
            align="center"
            min-width="100"
            show-overflow-tooltip
            label="密码"
          >
          </el-table-column>
          <el-table-column
            align="center"
            show-overflow-tooltip
            min-width="100"
            label="状态"
          >
            <template slot-scope="scope">
              <span>
                {{ scope.row.enable === 1 ? "启用" : "禁用" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="student.register"
            align="center"
            min-width="100"
            show-overflow-tooltip
            label="创建时间"
          >
            <template slot-scope="scope">
              <span>
                {{ new Date(scope.row.register).$Format("yyyy/MM/dd") }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            min-width="100"
            prop="date"
            align="center"
            fixed="right"
            label="操作"
          >
            <template slot-scope="scope">
              <span>
                <img
                  @click="showModal(scope.row, 'edit', '')"
                  src="@/assets/image/bianji.png"
                  alt=""
                  width="20"
                  height="20px"
                  style="cursor: pointer;margin-right: 4px"
                />
              </span>
              <span v-if="scope.row.enable === 1">
                <el-popconfirm
                  title="确定禁用该用户吗？"
                  @confirm="enabledAccount(scope.row, 0)"
                >
                  <img
                    slot="reference"
                    src="@/assets/image/qiyong.png"
                    alt=""
                    width="18"
                    height="18"
                    style="cursor: pointer;margin-right: 4px"
                  />
                </el-popconfirm>
              </span>
              <span v-else>
                <el-popconfirm
                  title="确定启用该用户吗？"
                  @confirm="enabledAccount(scope.row, 1)"
                >
                  <img
                    slot="reference"
                    src="@/assets/image/jinyong.png"
                    alt=""
                    width="18"
                    height="18"
                    style="cursor: pointer;margin-right: 4px"
                  />
                </el-popconfirm>
              </span>
              <span>
                <el-popconfirm
                  title="确定删除该用户吗？"
                  @confirm="delateAccount(scope.row)"
                >
                  <img
                    slot="reference"
                    src="@/assets/image/shanchu.png"
                    alt=""
                    width="18"
                    height="18"
                    style="cursor: pointer;"
                  />
                </el-popconfirm>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination
          :page-size="searchParams.pagination.pageSize"
          :page-count="5"
          :pager-count="5"
          class="tea-pagination"
          prev-text="上一页"
          next-text="下一页"
          layout="prev, pager, next"
          @current-change="
            (index) => {
              searchParams.pagination.pageNo = index;
              getList();
            }
          "
          :current-page="searchParams.pagination.pageNo"
          :total="searchParams.pagination.total"
        >
        </el-pagination>
        <div class="handler-wrap">
          <button @click="showModal({}, 'add', 'register')">
            <div>
              新建账号
            </div>
            <div>
              New account
            </div>
          </button>
          <el-dialog
            append-to-body
            class="add-modal modal-title"
            title="提示"
            :visible.sync="addModal"
            @open="isBlur(true)"
            @close="isBlur(false)"
            width="734px"
          >
            <div slot="title" class="title">
              <div class="text">{{ edit ? "编辑" : "新建" }}账号</div>
              <div class="sub-text">
                add new account
              </div>
            </div>
            <div>
              <el-form
                :inline="true"
                label-position="top"
                :model="registerData"
                :rules="registerDataRules"
                ref="register"
              >
                <el-form-item style="position: absolute;z-index: -1;">
                  <el-input type="text"></el-input>
                  <el-input type="password"></el-input>
                </el-form-item>
                <el-form-item label="账号" prop="userName">
                  <el-input
                    v-model="registerData.userName"
                    auto-complete="false"
                  ></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                  <el-input
                    v-model="registerData.password"
                    type="password"
                    auto-complete="false"
                  ></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="realName">
                  <el-input v-model="registerData.realName"></el-input>
                </el-form-item>
                <el-form-item label="学号" prop="studentNo">
                  <el-input v-model="registerData.studentNo"></el-input>
                </el-form-item>
                <el-form-item label="学校" prop="schoolName">
                  <el-input v-model="registerData.schoolName"></el-input>
                </el-form-item>
                <el-form-item label="班级" prop="className">
                  <el-input v-model="registerData.className"></el-input>
                </el-form-item>
                <el-form-item
                  style="text-align:center;width: 100%;margin-top: 10px"
                >
                  <button
                    class="submitbtn"
                    @click.prevent="saveAccount('register')"
                    style="width: 278px;height: 60px;text-transform:uppercase"
                  >
                    <div>
                      保存 preservation
                    </div>
                  </button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
          <button @click="importModal = true">
            <div>
              导入账号
            </div>
            <div>
              Import account number
            </div>
          </button>
          <el-dialog
            append-to-body
            class="import-modal modal-title"
            title="提示"
            :visible.sync="importModal"
            @open="isBlur(true)"
            @close="isBlur(false)"
            width="734px"
          >
            <div slot="title" class="title">
              <div class="text">
                导入账号
              </div>
              <div class="sub-text">
                add new account
              </div>
            </div>
            <div class="content">
              <div class="label">
                导入文件
              </div>
              <div class="uploader-wrap">
                <div class="uploader-btn" @click="uploading">
                  {{ uploadFileName ? uploadFileName : "点击上传文件" }}
                </div>
                <button
                  class="submitbtn"
                  style="width: 176px;height: 54px;text-transform:uppercase"
                >
                  <div @click="uploading">
                    浏览 BROWSE
                  </div>
                </button>
              </div>
              <div class="info">
                导入文件类型必须为Excel格式
                <a
                  href="/resource/template/uploader_student.xlsx"
                  target="_blank"
                  >（点击下载模板）</a
                >
              </div>
            </div>
            <div class="footer" style="display: none">
              <button
                class="submitbtn"
                style="width: 278px;height: 60px;text-transform:uppercase"
              >
                <div>
                  上传 uploading
                </div>
              </button>
            </div>
          </el-dialog>
          <el-upload
            style="position: absolute;z-index: -1"
            class="upload-demo"
            action="/manager/student/uploader"
            :on-success="uploadSucceed"
          >
            <el-button size="small" type="primary" ref="uploadbtn"
              >点击上传</el-button
            >
          </el-upload>
          <button @click.prevent="exportStudent">
            <div>
              导出账号
            </div>
            <div>
              Export account number
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      list2: [],
      searchParams: {
        pagination: {
          pageNo: 1,
          pageSize: 10,
          type: true,
          total: 0,
        },
        student: {
          userName: "",
          realName: "",
          studentNo: "",
          className: "",
          schoolName: "",
        },
      },
      addModal: false,
      edit: false,
      registerData: {
        userName: "",
        password: "",
        password2: "",
        realName: "",
        studentNo: "",
        className: "",
        schoolName: "",
      },
      registerDataRules: {
        userName: [
          { required: true, message: "请输入账号名称", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        realName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
        studentNo: [{ required: true, message: "请输入学号", trigger: "blur" }],
        className: [
          { required: true, message: "请输入班级名称", trigger: "blur" },
        ],
        schoolName: [
          { required: true, message: "请输入学校名称", trigger: "blur" },
        ],
      },
      importModal: false,
      uploadFileName: "",
      clazzTotal: "",
      studentTotal: "",
    };
  },
  created() {
    this.getList();
    this.$axios
      .post("/manager/student/list", {
        pagination: {
          pageNo: 1,
          pageSize: 99999,
          type: true,
          total: 0,
        },
        student: {
          userName: "",
          realName: "",
          studentNo: "",
          className: "",
          schoolName: "",
        },
      })
      .then((res) => {
        if (res.succeed) {
          const uniqueClazzArray = res.items
            .map((obj) => obj.className) // 提取所有的 clazz 值
            .filter((value, index, self) => self.indexOf(value) === index); // 筛选出不重复的 clazz 值
          this.clazzTotal = uniqueClazzArray.length;
          this.studentTotal = res.items.length;
        }
      });
  },
  methods: {
    getList() {
      this.$axios
        .post("/manager/student/list", this.searchParams)
        .then((res) => {
          if (res.succeed) {
            this.list = res.items;
            this.searchParams.pagination = res.pagination;
          }
        });
    },
    isBlur(type) {
      switch (type) {
        case true:
          document.querySelector("#app").classList.add("blur");
          break;
        case false:
          document.querySelector("#app").classList.remove("blur");
          break;
      }
    },
    showModal(data, type, formname) {
      switch (type) {
        case "add":
          this.edit = false;
          this.addModal = true;
          this.$nextTick(() => {
            this.$refs[formname].resetFields();
          });
          break;
        case "edit":
          this.edit = true;
          this.addModal = true;
          this.registerData.id = data.id;
          this.$nextTick(() => {
            for (let i in this.registerData) {
              this.registerData[i] = data[i];
            }
          });
          break;
      }
    },
    saveAccount(formname) {
      let url = this.edit
        ? "/manager/student/modify"
        : "/manager/student/create";
      this.$refs[formname].validate((v) => {
        if (v) {
          this.$axios.post(url, this.registerData).then((res) => {
            if (res.succeed) {
              this.$message({
                message: res.message,
                type: "success",
              });
              this.addModal = false;
              this.$refs[formname].resetFields();
              this.getList();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        }
      });
    },
    enabledAccount(data, type) {
      this.$axios
        .post("/manager/student/modify", { id: data.id, enable: type })
        .then((res) => {
          if (res.succeed) {
            this.getList();
            this.$message({
              message: res.message,
              type: "success",
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        });
    },
    delateAccount(data) {
      this.$axios
        .post("/manager/student/delete", { id: data.id })
        .then((res) => {
          if (res.succeed) {
            this.getList();
            this.$message({
              message: res.message,
              type: "success",
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        });
    },
    uploading() {
      this.$refs["uploadbtn"].$el.click();
    },
    uploadSucceed(res, file) {
      this.uploadFileName = file.name;
      if (res.succeed) {
        this.$message({
          message: res.message,
          type: "success",
        });
        this.importModal = false;
        this.uploadFileName = "";
        this.getList();
      } else {
        let html = res.message;
        res.items.forEach((item, index) => {
          html += `<div>${index + 1} - ${item.message}</div>`;
        });
        this.$message({
          dangerouslyUseHTMLString: true,
          message: html,
          type: "error",
        });
      }
    },
    exportStudent() {
      this.$axios
        .post("/manager/student/download", this.searchParams)
        .then((res) => {
          if (res.succeed) {
            this.$openNewWindow(res.redirect);
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.main-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  min-width: 300px;
  background: #ffffff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 12px;

  .header {
    display: flex;
    height: 96px;
    line-height: 96px;
    background: linear-gradient(360deg, #005be7 0%, #70a0eb 100%);
    opacity: 1;
    border-radius: 12px 12px 0px 0px;
    font-size: 30px;
    font-weight: 400;
    color: #ffffff;
    padding: 0 20%;

    div.nav-item {
      cursor: pointer;
      width: 50%;
      text-align: center;

      div.txt {
        padding: 0 20px;
        display: inline-block;
        height: 96px;
        position: relative;
        font-weight: 400;
      }

      &.active {
        .txt {
          font-weight: bold;
        }

        .txt:before {
          content: "";
          position: absolute;
          bottom: 1px;
          left: 0;
          width: 100%;
          height: 8px;
          background: white;
        }
      }
    }
  }

  .search-wrap {
    width: 100%;
    padding: 24px 24px 0 24px;
    display: flex;

    .input {
      input {
        width: 100%;
        font-family: "Microsoft YaHei", sans-serif;
        height: 48px;
        background: #f2f2f2;
        opacity: 1;
        border-radius: 12px;
        font-size: 18px;
        color: #999999;
        padding: 0 20px;
      }
    }

    .btn {
      button {
        width: 100%;
        height: 48px;
        background: linear-gradient(
          90deg,
          rgba(119, 166, 239, 0.97) 0%,
          #005be7 100%
        );
        box-shadow: 0px 1px 4px rgba(119, 166, 239, 0.97);
        opacity: 1;
        border-radius: 60px;
        font-size: 20px;
        font-family: Microsoft YaHei UI, sans-serif;
        font-weight: 400;
        line-height: 22px;
        color: #ffffff;
        text-transform: uppercase;
      }
    }
  }

  .main {
    height: calc(100% - 168px);
    padding: 24px;

    ::v-deep .my-header {
      background: #70a0eb;
      font-size: 18px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: 400;
      color: #ffffff;
    }

    ::v-deep .el-table--small {
      font-size: 14px;
    }

    .table-wrap {
      border-radius: 8px;
      height: calc(100% - 130px);
      overflow: hidden;
    }

    @media screen and (max-width: 1600px) {
      .pagination-wrap {
        flex-direction: column;

        .tea-pagination {
          align-self: flex-start;
        }

        .handler-wrap {
          align-self: flex-end;
        }
      }
    }

    .pagination-wrap {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .handler-wrap {
        button {
          width: 153px;
          height: 44px;
          background: linear-gradient(315deg, #005be7 0%, #70a0eb 100%);
          opacity: 1;
          border-radius: 60px;
          color: white;
          margin-right: 12px;

          &:last-child {
            margin-right: 0;
          }

          div:nth-child(1) {
            font-size: 18px;
            line-height: 18px;
            font-family: "Microsoft YaHei", sans-serif;
            margin-bottom: 2px;
          }

          div:nth-child(2) {
            font-size: 10px;
            line-height: 10px;
            font-family: "Microsoft YaHei", sans-serif;
            letter-spacing: -0.5px;
          }
        }
      }
    }
  }
}

.add-modal {
  .title {
    padding: 0 12px;

    .text {
      height: 33px;
      font-size: 26px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: bold;
      line-height: 33px;
      color: #454b60;
    }

    .sub-text {
      height: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: 400;
      line-height: 15px;
      color: #999999;
      text-transform: uppercase;
    }
  }

  ::v-deep .el-form-item {
    width: calc(50% - 36px);

    &:nth-child(even) {
      margin-right: 62px;
    }

    .el-form-item__label {
      font-size: 18px;
      line-height: 18px;
    }

    .el-input__inner {
      height: 54px;
      background: #ffffff;
      border: 2px solid #f1f1f1;
      border-radius: 12px;
      line-height: 54px;
    }
  }
}

.import-modal {
  .title {
    padding: 0 12px;

    .text {
      height: 33px;
      font-size: 26px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: bold;
      line-height: 33px;
      color: #454b60;
    }

    .sub-text {
      height: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: 400;
      line-height: 15px;
      color: #999999;
      text-transform: uppercase;
    }
  }

  .content {
    .label {
      height: 23px;
      font-size: 18px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: 400;
      line-height: 23px;
      color: #999999;
      margin-bottom: 8px;
    }

    .uploader-wrap {
      display: flex;
      margin-bottom: 20px;

      .uploader-btn {
        cursor: pointer;
        width: 476px;
        height: 54px;
        padding: 0 24px;
        line-height: 54px;
        font-size: 22px;
        font-weight: 400;
        color: #999999;
        background: #ffffff;
        border: 2px solid #f1f1f1;
        opacity: 1;
        border-radius: 12px;
        margin-right: 18px;
      }
    }

    .info {
      text-align: center;
      height: 23px;
      font-size: 18px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: 400;
      line-height: 23px;
      color: #999999;
      margin-bottom: 28px;

      span {
        color: #70a0eb;
      }
    }
  }

  .footer {
    text-align: center;
  }
}
</style>
